import { createContext, useContext, useState, ReactNode } from 'react';

export interface SelectedJob {
  id: string;
  title: string;
  company: string;
  location?: string;
  salary?: string;
  description?: string;
  url: string;
  source: 'jsearch' | 'apify_linkedin' | 'saved';
  apply_type?: 'EASY_APPLY' | 'EXTERNAL';
  posted_at?: string;
  logo?: string;
}

interface JobContextType {
  selectedJob: SelectedJob | null;
  setSelectedJob: (job: SelectedJob | null) => void;
  clearSelectedJob: () => void;
}

const JobContext = createContext<JobContextType | undefined>(undefined);

export function JobContextProvider({ children }: { children: ReactNode }) {
  const [selectedJob, setSelectedJob] = useState<SelectedJob | null>(null);

  const clearSelectedJob = () => setSelectedJob(null);

  return (
    <JobContext.Provider value={{ selectedJob, setSelectedJob, clearSelectedJob }}>
      {children}
    </JobContext.Provider>
  );
}

export function useJobContext() {
  const context = useContext(JobContext);
  if (!context) {
    throw new Error('useJobContext must be used within JobContextProvider');
  }
  return context;
}
